module.exports = new __parcel__URL__("vision_1.d9625fe2.png").toString();